import React from 'react';
import ReactDOM from 'react-dom/client';

import reportWebVitals from './reportWebVitals';
import { BrowserRouter, Route,Routes} from 'react-router-dom';
import Home from './Components/Home';
import About from './Components/About';
import Contact from './Components/Contact';
import Products from './Components/Products';
import Terms from './Components/Terms';
import Privacy from './Components/Privacy';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
<BrowserRouter>
  <Routes>
      <Route path="/" element={ <Home />} /> 
      <Route path="/about" element={ <About />} /> 
      <Route path="/contact" element={ <Contact />} /> 
      <Route path="/products" element={ <Products />} /> 
      <Route path="/terms-and-conditions" element={ <Terms />} /> 
      <Route path="/privacy-policy" element={ <Privacy />} /> 
     
      
  </Routes>
</BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
